/*******************************************************************************
 * ADOBE CONFIDENTIAL
 * ___________________
 *
 * Copyright 2026 Adobe
 * All Rights Reserved.
 *
 * NOTICE: All information contained herein is, and remains
 * the property of Adobe and its suppliers, if any. The intellectual
 * and technical concepts contained herein are proprietary to Adobe
 * and its suppliers and are protected by all applicable intellectual
 * property laws, including trade secret and copyright laws.
 * Dissemination of this information or reproduction of this material
 * is strictly forbidden unless prior written permission is obtained
 * from Adobe.
 ******************************************************************************/

import styled from "styled-components";
import Popover from "components/shared/Popover";
import { devices } from "components/shared/Styles";

export const PaddedPopover = styled(Popover)`
  padding: 32px;
  min-width: 326px;
  align-items: start;
  border-radius: 32px;
  box-shadow: var(--phonos-box-shadow);

  ${devices.small} {
    min-width: calc(100vw - 14px);
  }
`;
